import { useEffect, useState } from "react";
import { subscribePrintJob } from "../services/reportExport";
import ReportDocument from "./ReportDocument";

/* Renders inside #report-print-root only while a print job is pending.
   The print stylesheet hides #app and shows #report-print-root, so the
   printed document is a dedicated render target — never the dashboard.

   The component owns the #report-print-root wrapper itself (ReportStyles.css
   and exportHtml both key off that id), so printing/HTML export keep working
   even if App.js is ever refactored. */
export default function ReportPrintDocument() {
  const [job, setJob] = useState(null);

  useEffect(() => subscribePrintJob((pending) => setJob(pending)), []);

  return (
    <div id="report-print-root">
      {job ? (
        <ReportDocument
          report={job.report}
          context={job.context}
          derived={job.derived}
          settings={job.settings}
          signoff={job.signoff}
          printMode
        />
      ) : null}
    </div>
  );
}